/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

 /**
  * author: hao
  */

const errorMapping = {
    "NetworkNumErr": "input",
    "RBB00001": "system",
    "RBB00002": "system",
    "RBB00003": "system",
    "RBB00101": "input",
    "RBB00102": "input",
    "RBB00103": "input",
    "RBB00106": "input",
    "RBB00107": "input",
    "RBB00108": "input",
    "OOB01": "input",
    "OOB02": "input",
    "OOB03": "input",
    "RBB00201": "input",
    "RBB00203": "input",
    "RBB00207": "system",
    "RBB00302": "input",
    "RBB02309": "input",
    "RBB02311": "input",
    "RBB02401": "system",
    "RBB01203": "input",
    "RBB01204": "system",
    // "400": "redirect",
    "401": "redirect",
    "RBB00010" :"redirect",
    "RBB00109": "input",
    "RBBOOB03": "system",
    "RBBOOB04": "input",
    "RBBOOB06": "input",
    "RBBOOB08": "input",
    "RBBOOB09": "input",
    "RBBOOB10": "input",
    "RBBOTP02": "system",
    "RBBOTP03": "system",
    "RBBOTP04": "system",
    "RBBOTP05": "system",
    "RBBOTP06": "system",
    "RBBOTP07": "system",
    "RBBOTP08": "system",
    "RBBOTP09": "system",
    "RBBOTP10": "system",
    "RBBOTP11": "system",
    "RBBOTP12": "system",
    "RBBOTP15": "system",
    "OTP01": "system",
    "OTP02": "system",
    "OTP03": "system",
    "OTP04": "system",
    "OTP05": "system",
    "OTP06": "system",
    "OTP07": "system",
    "OTP08": "system",
    "OTP09": "system",
    "OTP10": "system",
    "RBB00512": "system",
    "RBB00513": "system"
}

export default errorMapping;


// WEBPACK FOOTER //
// ./src/config/errorMapping.js